import React, { MutableRefObject, useEffect, useRef } from "react";
import { Input, Form } from "antd";
import { TextAreaRef } from "antd/lib/input/TextArea";
import { TextAreaProps as AntdTextAreaProps } from "antd/lib/input";
import { AppPartType } from "../../AppForm/types";
import { ROW_HEIGHT } from "../../AppForm/constants";

interface Props {
  nameItem: string;
  isDisable?: boolean;
  isTable?: boolean;
  item: AppPartType;
  preview?: boolean;
  style?: React.CSSProperties;
  styleColor?: React.CSSProperties;
  className?: string;
}

const TextAreaCustom: React.FC<Props> = (props) => {
  const {
    nameItem,
    item,
    preview,
    style,
    isDisable,
    isTable,
    styleColor = {},
    className,
  } = props;

  const isHiddenLabel = item?.is_hide_name;
  const labelText = item?.label_text;
  const minChar = item.min_num_char || item.item_config_data?.min_num_char;
  const maxChar = item.max_num_char || item.item_config_data?.max_num_char;
  const textAreaRef = useRef<TextAreaRef>(null);
  const minHeight = item.item_config_data.h * ROW_HEIGHT - 30;
  const form = Form.useFormInstance();
  const handleChangeLayByTextArea = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    e.target.style.height = minHeight + "px";
    e.target.style.height = e.target.scrollHeight + "px";
  };

  const handleRemoveEmptyStringTextArea = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    nameItem: string,
  ) => {
    if (e.target.value) {
      const value = e.target.value;
      const newValue = value.replace(/^\s+|\s+$/g, ""); //  trim()
      form.setFieldValue(nameItem, newValue);
      setTimeout(() => {
        handleChangeLayByTextArea(e);
      }, 10);
    }
  };

  useEffect(() => {
    if (textAreaRef.current?.resizableTextArea) {
      textAreaRef.current.resizableTextArea.textArea.style.height =
        minHeight + "px";
      textAreaRef.current.resizableTextArea.textArea.style.height =
        textAreaRef.current.resizableTextArea.textArea.scrollHeight + "px";
    }
  }, [isDisable]);

  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;

  return (
    <div key={item.id} style={style} className="container-area" id={item.id}>
      {isShowOnlyValue && value && (
        <div className="value_text_container">
          <pre
            style={{ ...style, whiteSpace: "pre-wrap", wordWrap: "break-word" }}
          >
            {value}
          </pre>
        </div>
      )}
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item?.is_required_field,
            message: `必須項目です`,
          },
          {
            min: minChar,
            message: `整数で指定のフィルードです。ご確認ください。`,
          },
          {
            max: maxChar,
            message: `整数で指定のフィルードです。ご確認ください。`,
          },
        ]}
        validateTrigger="onBlur"
        className={className}
      >
        <Input.TextArea
          ref={textAreaRef}
          style={{
            overflow: "hidden",
            ...styleColor,
          }}
          onChange={handleChangeLayByTextArea}
          onBlur={(e) => handleRemoveEmptyStringTextArea(e, nameItem)}
        />
      </Form.Item>
    </div>
  );
};

TextAreaCustom.displayName = "TextAreaCustom";
export default TextAreaCustom;
